import { stickerUrl } from "@listou/shared/stickers";
import { Link } from "@tanstack/react-router";
import { Check } from "lucide-react";

import { Sticker } from "../list-page/parts";
import { LogoMark } from "../logo";

const POINTS = [
  "Vos proches réservent leur cadeau : rien n’arrive en double.",
  "Un QR code pour le faire-part, sans compte pour vos proches.",
  "Une envie de n’importe quelle boutique : collez le lien.",
];

/**
 * A reminder of what the site is for, beside the statistics: a visitor reading about a
 * first name is very likely expecting a child. Sticky on wide screens, below the content
 * on phones (where the page's closing banner says the same).
 */
export function ListouAside() {
  return (
    <aside
      aria-label="Listou"
      className="rounded-3xl border border-line bg-butter/40 p-6 lg:sticky lg:top-6"
    >
      <div className="flex items-center gap-3">
        <LogoMark className="size-9" />
        <p className="font-display text-xl font-bold">Listou</p>
      </div>
      <Sticker
        src={stickerUrl("bebe", "nounours")}
        className="mx-auto my-4 block size-28 object-contain"
      />
      <h2 className="text-2xl font-bold">Un bébé en route ?</h2>
      <p className="mt-2 text-muted">
        Créez votre liste de naissance gratuite et partagez-la avec vos proches.
      </p>
      <ul className="mt-4 space-y-2 text-sm">
        {POINTS.map((point) => (
          <li key={point} className="flex gap-2">
            <Check size={16} className="mt-0.5 shrink-0 text-fir" aria-hidden="true" />
            {point}
          </li>
        ))}
      </ul>
      <Link to="/" className="btn mt-6 w-full justify-center">
        Créer ma liste de naissance
      </Link>
      <Link
        to="/exemple"
        search={{ occasion: "birth" }}
        className="mt-3 block text-center text-sm underline"
      >
        Voir un exemple de liste
      </Link>
    </aside>
  );
}
